// Lógica do método "Centena Matadora" - desdobramento progressivo de centena base.
// Não altera/remova outros utilitários — módulo isolado.

const pad3 = (n: number) => String(((n % 1000) + 1000) % 1000).padStart(3, "0");

const uniq = (arr: string[]) => Array.from(new Set(arr));

// Coluna 1: Centena seca + 3 vizinhas (base, base+1, base-1, base+2)
export const gerarCentenaSeca = (base: string): string[] => {
  const n = parseInt(base, 10);
  return uniq([pad3(n), pad3(n + 1), pad3(n - 1), pad3(n + 2)]).slice(0, 4);
};

// Coluna 2: Permutações dos 3 dígitos da base (até 6 + 4 vizinhas = 10)
export const gerarDesdobramentoCurto = (base: string): string[] => {
  const [a, b, c] = base.split("");
  const perms = uniq([
    `${a}${b}${c}`, `${a}${c}${b}`, `${b}${a}${c}`,
    `${b}${c}${a}`, `${c}${a}${b}`, `${c}${b}${a}`,
  ]);
  const n = parseInt(base, 10);
  const vizinhas = [pad3(n + 10), pad3(n - 10), pad3(n + 100), pad3(n - 100)];
  return uniq([...perms, ...vizinhas]).slice(0, 10);
};

// Coluna 3: Permutações + giro de dezena na base (20)
export const gerarDesdobramentoMedio = (base: string): string[] => {
  const curto = gerarDesdobramentoCurto(base);
  const centena = base[0];
  const giroDezena: string[] = [];
  for (let d = 0; d <= 9; d++) {
    const dz = String(d).padStart(2, "0");
    giroDezena.push(`${centena}${dz[0]}${dz[1]}`);
  }
  return uniq([...curto, ...giroDezena]).slice(0, 20);
};

// Coluna 4: Cobertura matadora (30)
export const gerarDesdobramentoMatador = (base: string): string[] => {
  const medio = gerarDesdobramentoMedio(base);
  const n = parseInt(base, 10);
  const variacoes: string[] = [];
  for (let off = -5; off <= 5; off++) variacoes.push(pad3(n + off));
  for (let off = -3; off <= 3; off++) variacoes.push(pad3(n + off * 10));
  return uniq([...medio, ...variacoes]).slice(0, 30);
};

export interface DesdobramentoCompleto {
  seca: string[];
  curto: string[];
  medio: string[];
  matador: string[];
}

export const gerarDesdobramentoCompleto = (base: string): DesdobramentoCompleto => ({
  seca: gerarCentenaSeca(base),
  curto: gerarDesdobramentoCurto(base),
  medio: gerarDesdobramentoMedio(base),
  matador: gerarDesdobramentoMatador(base),
});

export const calcularCusto = (
  totalCentenas: number,
  posicoes: number,
  valorAposta: number
): number => totalCentenas * posicoes * valorAposta;

export const isCentenaValida = (v: string): boolean => /^\d{3}$/.test(v);
